const SegmentEventType = {
  experiment_exposure: "experiment:exposure",
  prismic_cli_start: "prismic-cli:start",
  prismic_cli_end: "prismic-cli:end"
};
const HumanSegmentEventType = {
  [SegmentEventType.experiment_exposure]: "$exposure",
  [SegmentEventType.prismic_cli_start]: "Prismic CLI Start",
  [SegmentEventType.prismic_cli_end]: "Prismic CLI End"
};
export {
  HumanSegmentEventType,
  SegmentEventType
};
//# sourceMappingURL=types.js.map
